module.exports = __webpack_public_path__ + "img/cultura3.6d523ac2.png";